import { jsx as _jsx } from "react/jsx-runtime";
import { HDSFeaturesContext } from './HDSFeaturesContext';
import { HDSThemeProvider } from './HDSThemeProvider';
export const HDSAppProvider = ({
  children,
  features = {
    nextThemeEnabled: false
  }
}) => {
  return /*#__PURE__*/_jsx(HDSFeaturesContext.Provider, {
    value: features,
    children: /*#__PURE__*/_jsx(HDSThemeProvider, {
      children: children
    })
  });
};